import {IDatasetConfig, DatasetActionOpenType, ListViewItemTypes } from 'app/interfaces';
import {fieldsMap} from './fields';
import generalForm from './forms/general.form';
import detailForm from './forms/detail.form';

const beforeCallDetail = {
	name: 'record',
	path: '/pivot/destinations/dataset/trip_resources/:parentRecordId/detail/:recordId',
};

export const PivotTripResourcesTripDestinationsConfig: IDatasetConfig = {
	name: 'pivot_trip_resources_trip_destinations',
	title: 'Destinazioni',
	singleTitle: 'Destinazione',
	ajaxDatasetCode: 'trip_destinations',
	fieldsMap: fieldsMap,
	supportProperties: false,
	enabledActions: {
		detail: true,
		create: true,
		edit: false,
		list: true
	},
	formConfigsMap: {
		generalForm,
		detailForm,
	},

	pivot: {
		pivotCode: 'destinations',
		foreignKey: 'trip_destination_id',
		parentDatasetCode: 'trip_resources',
		commandSync: 'tpl1_trip_resources_pivots'
	},
	defaultActions: {
		detail: {
			openType: DatasetActionOpenType.DIALOG,
			beforeCalls: [ beforeCallDetail ],
			viewConfig: {
				formConfig: detailForm,
				actions: {
					edit: false,
					delete: false
				}
			}
		},
		create: {
			openType: DatasetActionOpenType.DIALOG,
			viewConfig: {
				formConfig: generalForm
			}
		},
		edit: {
			openType: DatasetActionOpenType.DIALOG,
			viewConfig: {
				formConfig: generalForm
			},
		},
		list: {
			openType: DatasetActionOpenType.PAGE,
			viewConfig: {
				itemViewType: ListViewItemTypes.TABLE,
				showSearchBar: true,
				defaultSortBy: 'created_at',
				defaultSortDirection: 'desc',
				columns: [
					{
						title: 'Nome',
						key: 'destination.description'
					},
					{
						title: 'Traduzioni Atttive',
						key: 'destination.active_language_codes'
					}
				],
				actions: ['create', 'detail', 'delete']
			}
		}
	}
};
